<template>
  <div>
    <div class="row">
      <div class="box col-xs-12 col-sm-6">
        <q-card>
        <q-card-title>
          {{$t('global.Summary')}}
        </q-card-title>
        <q-card-separator />
        <q-card-main v-if="summary">
          <div class="row text-faded">
            <div class="col-6 ">{{$t('global.PeriodOfTime')}}</div>
            <div class="col-6 ">{{$t('global.HourMin5')}}</div>
          </div>
          <q-card-separator />
          <div class="row ">
            <div class="col-6">{{$t('global.Day')}}</div>
            <div class="col-6">{{elapsedFormat(summary.TodayMinutesUp)}}</div>
          </div>
          <div class="row ">
            <div class="col-6">{{$t('global.Week')}}</div>
            <div class="col-6">{{elapsedFormat(summary.WeekMinutesUp)}}</div>
          </div>
          <div class="row ">
            <div class="col-6">{{$t('global.Month')}}</div>
            <div class="col-6">{{elapsedFormat(summary.MontMinutesUp)}}</div>
          </div>
          <div class="row ">
            <div class="col-6">{{moment(dateFrom).format($store.state.session.DateTimeFormat.substr(0, 10))}} - {{moment(dateTo).format($store.state.session.DateTimeFormat.substr(0, 10))}}</div>
            <div class="col-6">{{elapsedFormat(summary.RangeMinutesUp)}}</div>
          </div>
        </q-card-main>
        </q-card>
      </div>
      <div class="box col-xs-12 col-sm-6">
        <q-card>
          <q-card-title>
            {{$t('global.CurrentWeek')}}
          </q-card-title>
          <q-card-separator />
          <q-card-main>
            <GChart
              type="BarChart"
              :data="chartData"
              :options="chartOptions"
            />
          </q-card-main>
        </q-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { openURL } from 'quasar'
import {eventBus} from '../../main'

import { GChart } from 'vue-google-charts'

export default {
  name: 'SummaryJournal',
  props: ['dateFrom', 'dateTo'],
  data: function () {
    return {
      summary: null,
      form: {
        SessionId: null
      },
      weekLabels: ['Mo', 'Di', 'Mi', 'Do','Fr', 'Sa', 'So'],
      chartData_xxx: [
        ['Mo', 'Di', 'Mi', 'Do','Fr', 'Sa', 'So'],
        [20,7,6,5,4,3,2],
      ],
      chartData: [
        ['Tag', 'Stunden'],
        ['Mo',  0],
        ['Di',  0],
        ['Mi',  0],
        ['Do',  0],
        ['Fr',  0],
        ['Sa',  0],
        ['So',  0]

        
      ],
      chartOptions: {
        legend: 'left',
        orientation:'horizontal',
        chart: {
          title: 'Aktuelle Woche',
          
        }
      }
    }     
  },
  methods: { 

    loadData(){    
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getWorkSummary"
      this.form.dateFrom = this.dateFrom
      this.form.dateTo = this.dateTo
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          if(response.status == 200){ 

            var strDays = this.$t('global.DaysOfWeek')
            var Day = strDays.split(',')

            this.summary = response.data
            this.chartData = []
            this.chartData.push(['Tag', 'Stunden'])
            this.chartData.push([Day[0],  round(response.data.Day1 / 60, 2)])
            this.chartData.push([Day[1],  round(response.data.Day2 / 60, 2)])
            this.chartData.push([Day[2],  round(response.data.Day3 / 60, 2)])
            this.chartData.push([Day[3],  round(response.data.Day4 / 60, 2)])
            this.chartData.push([Day[4],  round(response.data.Day5 / 60, 2)])
            this.chartData.push([Day[5],  round(response.data.Day6 / 60, 2)])
            this.chartData.push([Day[6],  round(response.data.Day7 / 60, 2)])
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {        
        this.$q.notify('Something Wrong.')      
        console.log(e);
      })
    },
    elapsedFormat(minutes){
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return h + ':' + m;
    }
  },
  computed:{
    
  },
  mounted() {
     this.loadData()
  },
  created () {
    eventBus.$on('workChange', (data) => {
      this.loadData()
    }),
    eventBus.$on('Bus_ChangeLocale', (data) => {
      this.loadData()
    })
  },
  components: {
    GChart
  },
  watch: {
    dateFrom: function (val) {
      this.loadData()
    },
    dateTo: function (val) {
      this.loadData()
    },
  },
  
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
</script>
<style scoped>
.box{
  padding: 10px;
}

</style>
